<template>
  <p-create v-if="$hasPermission('workflows')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import CreateWorkflow from '../components/workflows/CreateWorkflow';

export default {
  components: {
    'p-create': CreateWorkflow,
    'p-not-found': NotFound
  }
};
</script>
